import appConfig from '../appConfig'

export const config = appConfig

const baseUrl = {
	//Admin
	movieList: `${appConfig.url.api}`,
}

export default baseUrl